import React, { useCallback, useEffect, useState } from "react";
import {
  Row,
  Col,
  Breadcrumb,
  Button,
  Grid,
  Card,
  Tabs,
  Modal,
  Skeleton,
  message,
} from "antd";
import { StarFilled } from "@ant-design/icons";
import photos from "assets/icons/photos.svg";
import Container from "commons/Container";
import { Link, useLocation, useNavigate } from "react-router-dom";
import facebook from "assets/icons/facebook.svg";
import google from "assets/icons/google.svg";
import overview from "assets/icons/overview.svg";
import Overview from "../Overview/Overview";
import { Storage } from "aws-amplify";
import { useDispatch, useSelector } from "react-redux";
import { setDoctorData } from "store/actions/doctorAction";
import Chat from "pages/user/SupportChatbox/Chat";

import { GetSurgeryCenterDetails, ListNearByDoctor } from "utility/action";
import { GetPublicFileFromS3 } from "utility/uploadFileToS3";
import ImageGallery from "utility/ImageGallery";
import { setSpecialityOption } from "store/actions/specialityOptions";
import {
  END_TOUR,
  SURGICAL_PROFILE_TOUR_START,
  SURGICAL_SELECT_DOCTOR_TOUR_END,
} from "utility/constant";
import TourStepContent from "utility/TourStepContent";
import GlobalJoyride from "utility/GlobalJoyride";
import { setTourSteps } from "store/actions/tourSteps";
import { surgeryMapDoctorSpeciality } from "utility/constant";

export default function SurgicalCenterDetail() {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const [surgeryData, setSurgeryData] = useState([]);
  const [skeletonLoader, setSkeletonLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isSupportModalOpen, setSupportIsModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("item-1");
  const [messageApi, contextHolder] = message.useMessage();

  const [testimonialData, setTestimonialData] = useState([
    { testimonialName: "", testimonialRating: "", review: "" },
  ]);
  const [surgicalPhoto, setSurgicalPhoto] = useState(null);
  const [preSignedImg, setPreSignedimg] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const surgeryCenterID = location?.state?.id;
  const userData = useSelector((state) => state.userReducer?.userData);
  const locationCoordinates = userData?.profile?.location;
  const specialityOptions = useSelector(
    (state) => state?.surgerySpecialityReducer?.surgerySpeciality
  );
  const [tour, setTour] = useState(false);
  const [tourIndex, setTourIndex] = useState(0);
  const tourSteps = useSelector((state) => state.tourReducer?.tourSteps);
  const search = location?.state?.search;

  const showModalSupport = () => {
    setSupportIsModalOpen(true);
  };

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  const handleOkSupport = () => {
    setSupportIsModalOpen(false);
  };

  const handleCancelSupport = () => {
    setSupportIsModalOpen(false);
  };

  const fetchSurgeryCenter = useCallback(async () => {
    try {
      setSkeletonLoader(true);
      const response = await GetSurgeryCenterDetails(surgeryCenterID);
      const testimonialData = JSON.parse(response?.testimonial ?? "[]");
      setTestimonialData(testimonialData);

      if (response?.surgeryCenterProfilePhoto) {
        let surgeryphoto;
        if (response?.surgeryCenterProfilePhoto.startsWith("http")) {
          surgeryphoto = response?.surgeryCenterProfilePhoto;
        } else {
          surgeryphoto = await GetPublicFileFromS3(
            response?.surgeryCenterProfilePhoto
          );
        }
        setSurgicalPhoto(surgeryphoto);
      }
      if (response?.surgeryPhotos) {
        const fileKeyy = response?.surgeryPhotos;
        const urls = [];
        for (const key of fileKeyy) {
          try {
            const url = await Storage.get(key, {
              level: "public",
              expires: 86400,
            });
            urls.push(url);
          } catch (error) {
            console.log(`Error getting pre-signed URL for ${key}: ${error}`);
          }
        }
        setPreSignedimg(urls);
      }
      setSurgeryData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setSkeletonLoader(false);
    }
  }, [surgeryCenterID]);

  useEffect(() => {
    fetchSurgeryCenter();
  }, [fetchSurgeryCenter]);

  const findDoctor = async (value) => {
    try {
      if (tour) {
        dispatch(setTourSteps(SURGICAL_SELECT_DOCTOR_TOUR_END));
        setTour(false);
      }
      setLoader(true);
      const responce = await ListNearByDoctor(
        999,
        {
          lat: locationCoordinates?.lat,
          lon: locationCoordinates?.lon,
        },
        undefined,
        surgeryMapDoctorSpeciality[specialityOptions],
        surgeryData?.surgeryCenterName
      );

      const surgeryCenterSpeciality = surgeryData?.specailtyAndBodyPart?.map(
        (value) => {
          return {
            label: surgeryMapDoctorSpeciality[value?.specialty],
            value: surgeryMapDoctorSpeciality[value?.specialty],
          };
        }
      );

      dispatch(setDoctorData(responce));
      dispatch(
        setSpecialityOption(surgeryMapDoctorSpeciality[specialityOptions])
      );
      navigate("/doctor-list", {
        state: {
          surgicalName: surgeryData?.surgeryCenterName,
          specialty: [specialityOptions],
          surgeryCenterSpeciality: surgeryCenterSpeciality,
        },
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };

  // For tabs icons
  const items = [
    {
      label: (
        <span className="sub-header-font d-flex align-center">
          <img src={overview} className="tabs-icon" />
          {(activeTab === "item-1" && screens.xs) || screens.sm || screens.lg
            ? "Overview"
            : ""}
        </span>
      ),
      key: "item-1",
      children: (
        <Overview data={surgeryData} loader={skeletonLoader} role="SURGERY" />
      ),
    },
    {
      label: (
        <span className="sub-header-font d-flex align-center">
          <img src={photos} className="tabs-icon" />
          {(activeTab === "item-2" && screens.xs) || screens.sm || screens.lg
            ? "Photos"
            : ""}
        </span>
      ),
      key: "item-2",
      children: <ImageGallery data={preSignedImg} />,
    },
    {
      label: "",
      key: "item-3",
      children: "",
    },
  ];

  useEffect(() => {
    if (tourSteps === SURGICAL_PROFILE_TOUR_START) {
      setTour(true);
      setTimeout(() => {
        dispatch(setTourSteps(END_TOUR));
      }, 500);
    }
  }, [tourSteps]);

  const handleEndTour = () => {
    setTour(false);
    dispatch(setTourSteps(END_TOUR));
  };

  const serviceSteps = [
    {
      target: ".sc-first-step",
      content: (
        <TourStepContent
          heading="Surgical Center Profile"
          details="Simply click on different tabs to explore all the details related to the Surgical Center."
          numbers={{ currentStep: 5, totalSteps: 7 }}
        />
      ),
      disableBeacon: true,
      spotlightClicks: true,
      placement: "bottom",
    },
    {
      target: ".sc-second-step",
      content: (
        <TourStepContent
          heading="Surgical Center Details"
          details="Simply click to select a doctor who is associated with the selected surgical center."
          numbers={{ currentStep: 6, totalSteps: 7 }}
        />
      ),
      disableBeacon: true,
      spotlightClicks: true,
      placement: "bottom",
    },
  ];

  return (
    <>
      {contextHolder}
      <Container>
        <GlobalJoyride
          steps={serviceSteps}
          run={tour}
          stepIndex={tourIndex}
          setTourIndex={setTourIndex}
        />
        {/* Sub Header Starts */}
        <Breadcrumb className="hide-version-no">
          <Breadcrumb.Item>
            <Link to="/" className="p-font">
              Home
            </Link>
          </Breadcrumb.Item>

          {!search && (
            <Breadcrumb.Item>
              <Link to="/surgical-center-list" className="p-font">
                Surgical Center List
              </Link>
            </Breadcrumb.Item>
          )}

          <Breadcrumb.Item>
            <span className="p-font">{surgeryData?.surgeryCenterName}</span>
          </Breadcrumb.Item>
        </Breadcrumb>

        <Card
          className="doctor-profile sc-first-step mobile-card"
          onClick={() => setTourIndex(1)}
        >
          <Row>
            {skeletonLoader ? (
              <>
                <Skeleton avatar paragraph={{ rows: 2 }}></Skeleton>{" "}
              </>
            ) : (
              <>
                <Col span={24}>
                  <Row justify="space-between" gutter={[0, 20]}>
                    <div className="d-flex gap-4">
                      <img src={surgicalPhoto} alt="" className="doctor-img" />
                      <div className="doctor-detail">
                        <h4 className="doctor-name mb-1 header-font">
                          {surgeryData?.surgeryCenterName}
                        </h4>
                        <div className="d-flex gap-3">
                          <p className="p-font">
                            <img src={facebook} alt="facebook Icon" />
                            {surgeryData?.surgeryCenterFaceBookRating
                              ? surgeryData?.surgeryCenterFaceBookRating
                              : 0}
                            <StarFilled style={{ color: "#e7a500" }} />
                          </p>

                          <p className="p-font">
                            <img src={google} alt="facebook Icon" />
                            {surgeryData?.surgeryCenterGoogleRating
                              ? surgeryData?.surgeryCenterGoogleRating
                              : 0}
                            <StarFilled style={{ color: "#e7a500" }} />
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className={screens.xs ? "w-100" : ""}>
                      <Button
                        className={
                          screens.xs
                            ? "w-100 theme-btn sc-second-step"
                            : "theme-btn sc-second-step"
                        }
                        onClick={findDoctor}
                        loading={loader}
                      >
                        Select a Doctor
                      </Button>
                      {/* </Link> */}
                    </div>
                  </Row>
                </Col>
              </>
            )}
          </Row>
        </Card>
        <Card className="profile-tabs mobile-card">
          <Row>
            <Col span={24}>
              <Tabs items={items} onChange={handleTabChange} />
            </Col>
          </Row>
        </Card>
      </Container>
    </>
  );
}
